import { useTranslation } from 'react-i18next';

export const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const setLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="flex items-center gap-1 rounded-lg border border-gray-200 bg-gray-50 p-0.5">
      <button
        className={`rounded-md px-2.5 py-1 text-xs font-medium transition-colors ${
          i18n.language.startsWith('en') ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-600 hover:text-gray-900'
        }`}
        type="button"
        onClick={() => setLanguage('en')}
      >
        EN
      </button>
      <button
        className={`rounded-md px-2.5 py-1 text-xs font-medium transition-colors ${
          i18n.language.startsWith('pt') ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-600 hover:text-gray-900'
        }`}
        type="button"
        onClick={() => setLanguage('pt')}
      >
        PT
      </button>
    </div>
  );
};
